import { render, staticRenderFns } from "./OrganisationSettings.vue?vue&type=template&id=0ece87b5&scoped=true&"
import script from "./OrganisationSettings.vue?vue&type=script&lang=js&"
export * from "./OrganisationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece87b5",
  null
  
)

export default component.exports